module.exports = __webpack_public_path__ + "img/empower.5293a493.png";